import { Controller } from '@hotwired/stimulus'

import { useDynamicFields } from '../mixins/useDynamicFields'

export default class extends Controller {
  connect () {
    useDynamicFields(this)
  }
}
